<div class="card" style="max-width: 407px">
  <div class="card-body">
    <h5 class="card-title">Change Password</h5>

    <form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword(changePasswordForm)">
      <div class="form-group mb-3">
        <label class="form-label">{{ 'change-password.currentPasswordLabel' | translate }}</label>

        <input
          class="form-control"
          name="password"
          formControlName="currentPassword"
          placeholder="{{ 'change-password.currentPasswordPlaceHolder' | translate }}"
          type="password"
          (focus)="onFocus()"
        />
      </div>

      <div class="form-group mb-3">
        <label class="form-label">{{ 'change-password.newPasswordLabel' | translate }}</label>
        
        <input
          name="password"
          formControlName="newPassword"
          type="password"
          (focus)="onFocus()"
          placeholder="{{ 'change-password.newPasswordPlaceHolder' | translate }}"
          class="form-control"
        />
      </div>

      <div class="form-group mb-3">
        <label class="form-label">{{ 'change-password.confirmPasswordLabel' | translate }}</label>

        <input
          class="form-control"
          formControlName="confirmPassword"
          name="password"
          placeholder="{{ 'change-password.confirmPasswordPlaceHolder' | translate }}"
          type="password"
          (focus)="onFocus()"
        />
      </div>

      <div
        class="d-flex justify-content-end align-items-center w-100"
        [class.justify-content-between]="!!error || !isNewPasswordCorrect"
      >
        <div *ngIf="!isNewPasswordCorrect" class="text-danger w-50">
          New password and confirmed password are different!
        </div>

        <div *ngIf="error" class="text-danger w-50">{{error}}</div>

        <button
          class="btn btn-primary"
          type="submit"
          [disabled]="!changePasswordForm.valid"
        >
          {{ 'change-password.changePasswordButton' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
<div class="card" style="max-width: 407px">
  <user-phone-number-form></user-phone-number-form>
</div>

<div class="card" style="max-width: 407px">
  <div class="card-body">
    <h5 class="card-title">Membership</h5>

    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <label>Cancel Subscription</label>

      <button class="btn btn-primary" id="cancel-subscription" type="button">Cancel</button>
    </div>
  </div>
</div>
